const updates = [
  { date: '2026.07.28', title: '刃牙道II第162话更新！相扑道篇白热化', tag: '最新' },
  { date: '2026.07.21', title: '刃牙道II第161话：力士VS格斗家终极对决', tag: '热门' },
  { date: '2026.07.14', title: '刃牙漫画总集篇：死刑犯篇经典回顾特辑上线', tag: '专题' },
  { date: '2026.07.07', title: '范马刃牙皮可篇精修版全章节整理完成', tag: '精修' },
  { date: '2026.06.30', title: '刃牙道II第160话：地下斗技场传说再现', tag: '更新' },
  { date: '2026.06.23', title: '刃牙漫画全系列阅读指南更新至最新进度', tag: '指南' },
  { date: '2026.06.16', title: '刃牙II中国大擂台篇高清重置版上线', tag: '重置' },
  { date: '2026.06.09', title: '刃牙道II第159话：相扑力士的秘密特训', tag: '更新' },
  { date: '2026.06.02', title: '刃牙外传：花山薰特别篇最新话公开', tag: '外传' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          更新快讯
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 max-w-lg mx-auto">
          刃牙漫画全系列最新更新动态，第一时间掌握连载进度
        </p>
        <div className="max-w-3xl mx-auto">
          {updates.map((item, i) => (
            <div
              key={i}
              className="flex items-start gap-4 py-4 border-b border-background-200/60 last:border-b-0 cursor-pointer hover:bg-background-50/60 transition-colors px-3 rounded-lg -mx-3"
            >
              <span className="text-xs text-foreground-500 whitespace-nowrap pt-0.5 font-medium">{item.date}</span>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground-800 leading-relaxed">{item.title}</p>
              </div>
              <span className={`px-2 py-0.5 text-[11px] font-medium rounded-full whitespace-nowrap flex-shrink-0 ${
                item.tag === '最新' ? 'bg-primary-100 text-primary-700' :
                item.tag === '热门' ? 'bg-accent-100 text-accent-700' :
                'bg-secondary-100 text-secondary-700'
              }`}>
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}